var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/recommendation_product.dbfc6369.png","uri@2x": __webpack_public_path__ + "static/media/recommendation_product.dbfc6369.png","uri@3x": __webpack_public_path__ + "static/media/recommendation_product.3b622511.png",
    width: 134,
    height: 134
});